/* Seamless hero -> next-section transition (homepage).
   Shows the full banner image and pins it (via CSS sticky) while the
   following section rises over it. JS only tags the two sections so the
   CSS can target them robustly regardless of their Shopify section IDs. */
(function () {
  'use strict';

  function init() {
    var main = document.querySelector('main, #MainContent') || document.body;

    // Hero = first shopify-section that contains a Dawn image banner.
    var sections = main.querySelectorAll(':scope > .shopify-section, :scope > section[id^="shopify-section"]');
    var hero = null;
    for (var i = 0; i < sections.length; i++) {
      if (sections[i].querySelector('.banner')) { hero = sections[i]; break; }
    }
    if (!hero) return;

    // Next = the following sibling section that actually renders content.
    var next = hero.nextElementSibling;
    while (next && !(next.id && next.id.indexOf('shopify-section') === 0) && next.children.length === 0) {
      next = next.nextElementSibling;
    }
    if (!next) return;

    hero.classList.add('seam-hero');
    next.classList.add('seam-next');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
